const get_started = {
    page_title: 'はじめに',
    title: 'あなたの成功を手助けする探索',
    subtitle: 'Logtoの価値を迅速に把握するための数つの方法',
    develop: {
        title: '開発: 5分の時間を使ってアプリを統合してみましょう',
        title_cloud: '開発: 数分でアプリを安全に統合する',
        subtitle_cloud: 'または、5分間でアプリを当社の事前構築済みSDKおよびチュートリアルで統合してください。',
        try_mcp: 'MCPで1プロンプト統合を試す',
    },
    customize: {
        title: 'カスタマイズ: 素晴らしいサインイン体験を提供する',
        preview: {
            title: 'あなたがカスタマイズしたサインイン体験のライブプレビューをチェックしましょう',
            subtitle: 'Logtoのサインイン体験を試して、その使い方を確認してください',
        },
        connector: {
            title: 'さらなるコネクタを追加して、さまざまなソーシャルサインイン方式をサポートしましょう',
            subtitle: 'パスワードレスサインインを試して、顧客に安全かつ摩擦のない体験を提供しましょう',
        },
        continue_customizing: 'カスタマイズを続ける',
        try_now: '今すぐ試す',
        add_more: 'もっと追加する',
    },
    secure: {
        title: 'セキュリティ: リソースを保護する',
    },
    manage: {
        title: '管理: 製品とユーザーのアクセス制御を定義する',
        rbac: {
            title: 'ロールベースのアクセス制御を追加して、リソースを保護する',
            subtitle: '多様なユースケースに対してスケーラブルなロールの認可によりリソースを制御します',
        },
        create_roles: 'ロールを作成する',
    },
    convert_to_production: {
        card_title: '公開準備はできていますか？ 本番設定を開始するのを忘れないでください！',
        title: '開発モードにプロジェクトをとどめないでください',
        subtitle: 'あなたは無料テストのために開発テナントを使用しています。公開するには、本番テナントを作成または変換してください。カスタムが必要ですか？ <a>お問い合わせください</a>',
        convert_button: '本番テナントに変換する',
    },
    oss_cloud: {
        try: {
            title: '運用作業を省いて Logto Cloud を無料で試す',
            badge: 'おすすめ',
            description: '保守不要のフルマネージド Logto に加え、MCP を使った迅速な統合、マルチテナント対応、チームコラボレーション、すべてのプレミアム機能を利用できます。クレジットカード不要で無料で始められます。',
            action: 'Logto Cloud を詳しく見る',
        },
        private_cloud: {
            title: 'コンプライアンスやカスタム導入が必要ですか？',
            card_title: 'プライベートクラウド',
            description: '完全なデータ分離、カスタムドメイン、SLA 保証を備えた専用の Logto インスタンスを利用できます。厳格なデータ所在地やコンプライアンス要件を持つ企業に最適です。インフラは私たちが管理するので、あなたは製品開発に集中できます。',
        },
    },
    view_all: 'すべての内容を表示 →',
};
export default Object.freeze(get_started);
